import * as i0 from '@angular/core';
i0.ComponentFactory;



// WEBPACK FOOTER //
// ./src/app/pro/pro.component.ngfactory.ts